import { defaultOnMutate, defaultOnSettled, defaultOnSuccess } from './mutation.js'
import { cleanQueryKey, getCrudListQueryKey } from './query_utils.ts'

// Mutation prefix for CRUD endpoint that automatically infers listQueryKey and rowId if needed

// CRUD endpoints assumes:
// - GET prefix/resource -> list
// - POST prefix/resource creates a new item and returns it
// - GET prefix/resource/:id -> single item
// - PUT/PATCH prefix/resource/:id -> single item
// - DELETE prefix/resource/:id -> NO_CONTENT

function getCrudId(queryKey) {
  const pathSegments = cleanQueryKey(queryKey).filter(key => typeof key !== 'object')
  return pathSegments.at(-1)
}

async function crudOnMutate(variables) {
  const { queryKey: rawQueryKey, listQueryKey: listQueryKeyRaw, rowId: rowIdRaw } = variables
  const queryKey = cleanQueryKey(rawQueryKey)
  const listQueryKey = listQueryKeyRaw ?? getCrudListQueryKey(queryKey, variables.verb)
  const rowId = rowIdRaw ?? getCrudId(queryKey)
  const context = await defaultOnMutate({ ...variables, listQueryKey, queryKey, rowId })

  return context
}

async function crudOnSuccess(data, variables, context) {
  const { queryKey: rawQueryKey, listQueryKey: listQueryKeyRaw, rowId: rowIdRaw } = variables
  const queryKey = cleanQueryKey(rawQueryKey)
  const listQueryKey = listQueryKeyRaw ?? getCrudListQueryKey(queryKey, variables.verb)
  const rowId = rowIdRaw ?? getCrudId(queryKey)

  await defaultOnSuccess(data, { ...variables, queryKey, listQueryKey, rowId }, context)
}

async function crudOnSettled(data, error, variables, context) {
  const { queryKey: rawQueryKey, listQueryKey: listQueryKeyRaw } = variables
  const queryKey = cleanQueryKey(rawQueryKey)
  const listQueryKey = listQueryKeyRaw ?? getCrudListQueryKey(queryKey, variables.verb)

  await defaultOnSettled(data, error, { ...variables, queryKey, listQueryKey }, context)
}

export { crudOnMutate, crudOnSettled, crudOnSuccess }
